module.exports = __webpack_public_path__ + "img/Epic.a02704f0.png";